import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FloatingLabel from '@getgo/chameleon-react/dist/FloatingLabel';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import debounce from 'lodash.debounce';
import classNames from 'classnames';
import './Search.css';

export class SearchOrganizers extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    users: PropTypes.array,
    onUserSelected: PropTypes.func,
    usedEmails: PropTypes.array,
    t: PropTypes.func,
    nextPage: PropTypes.number,
    creatorsFetching: PropTypes.bool.isRequired,
    page: PropTypes.number.isRequired,
    getCreators: PropTypes.func.isRequired
  };

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static defaultProps = {
    placeholder: 'Search'
  };
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      searchText: '',
      page: props.page
    };
    this.oraganizerFilterDropdownMenu = null;
  }

  onScroll = event => {
    const { getCreators, creatorsFetching, nextPage } = this.props;
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const { page } = this.state;
    if (scrollTop + clientHeight >= scrollHeight && !creatorsFetching && nextPage) {
      getCreators(page + 1);
      this.setState({ page: page + 1 });
    }
  };

  toggleDropdown = () => {
    this.setState({ showDropdown: !this.state.showDropdown }, () => {
      const oraganizerFilterDropdownMenu = document.getElementById('oraganizerFilterDropdownMenu');
      if (this.state.showDropdown) {
        if (oraganizerFilterDropdownMenu) {
          oraganizerFilterDropdownMenu.addEventListener('scroll', this.onScroll);
        }
      } else {
        if (oraganizerFilterDropdownMenu) {
          oraganizerFilterDropdownMenu.removeEventListener('scroll', this.onScroll);
        }
      }
    });
  };

  handleCreatorsSearch = () => {
    const { getCreators } = this.props;
    getCreators(0, this.state.searchText, true);
  };

  fetchCreatorsDebounced = debounce(this.handleCreatorsSearch, 500);

  onChange = value => {
    const trimmed = value.trim();
    this.setState({ searchText: trimmed, showDropdown: trimmed.length > 0 }, this.fetchCreatorsDebounced);
  };

  renderSearchItems() {
    const { t } = this.context;
    const { users = [], usedKeys = [], creatorsFetching } = this.props;
    return users.length > 0
      ? users.map((u, index) => {
          const alreadyAdded = usedKeys.includes(u.staffKey);
          return (
            <DropdownItem
              key={`id_${u.staffKey}_${index}`}
              className="dropdownMenuItem"
              disabled={alreadyAdded}
              onClick={() => this.props.onUserSelected(u)}>
              <div className="nameAndEmailContainer">
                <label
                  id={`id_${u.staffKey}${u.name}${index}`}
                  className={classNames('organizerName', { darkText: !alreadyAdded })}>
                  {u.name}
                </label>
                <label id={`id_${u.staffKey}${u.email}${index}`} className="organizerEmail">
                  {u.email}
                </label>
              </div>
              {alreadyAdded ? <i className="togo-icon togo-icon-check" /> : null}
            </DropdownItem>
          );
        })
      : !creatorsFetching && (
          <DropdownItem className="noResultFoundItem">
            <label>{t('organizerFilter.noSearchResultsFound')}</label>
          </DropdownItem>
        );
  }

  render() {
    const { creatorsFetching } = this.props;
    return (
      <Dropdown
        id="session_organizer_filter_search_dropdown"
        isOpen={this.state.showDropdown}
        toggle={this.toggleDropdown}>
        <DropdownToggle className="searchContainer" aria-expanded={this.state.dropdownOpen} tag="div">
          <FloatingLabel
            id="edit_staff_search"
            form
            autoFocus
            floatLabel={false}
            showAnimatedBar
            inputClassName="textInputField"
            placeholder={this.props.placeholder}
            onChange={this.onChange}
            onClick={this.toggleDropdown}
          />
          <i className="togo-icon togo-icon-search" />
        </DropdownToggle>
        <DropdownMenu tabIndex="0" autoFocus className="dropdownMenu" id="oraganizerFilterDropdownMenu">
          {this.renderSearchItems()}
          {creatorsFetching && (
            <DropdownItem key="creators-loading" className="dropdownMenuItem searchLoaderContainer">
              <div className="searchLoader">
                <span className="edge edgeLeft"></span>
                <span className="edge edgeRight"></span>
              </div>
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default SearchOrganizers;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Admin/Filters/Search/Search.js